<template>
    <div name="home-header" class="header">
        <img class="logo" src="../../../assets/concierge_logo.png" />
        <div @click="logout" class="logout-button">로그아웃</div>
    </div>
</template>

<script>
export default {
    name: 'homeHeader',
    methods: {
        logout: function()
        {
            this.$emit('logout')
        }
    }
}
</script>

<style scoped>
    .header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 24px 16px;
    }
    .logo {
        width: 119px;
    }
    .logout-button {
        display: flex;
        height: 28px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        padding: 0px 8px;
        color: #1D4A94;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/home/HomeHeader.vue